export default __webpack_public_path__ + "static/media/3606.d60dc2ed.png";